//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'BODEx',
  data () {
    return {
      defaultJson: {
        "All exacerbation episodes requiring hospital management (emergency visits or admissions) during the previous year.": "过去一年中需要入院治疗（急诊或住院）的所有急性加重的发作次数。",
        "Body Mass Index": "体重指数",
        "Dyspnea Scale": "呼吸困难分级",
        "BODEx": "BODEx",
        "Number of AECOPD": "COPD 急性加重次数",
        "FEV₁ (% predicted)": "FEV₁（% 预测值）"
      },
      form: {
        mrcdyspnea:'',
        b:'',
        f:'',
        s:''
      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        self.mortalityFirst = '--'
        self.mortalityLong = '--'
        self.scoreUpdated = '--'
        return '--'
      } else {
        console.log(form)
        	// (b <= 21 ? 1 : 0) + (mrcdyspnea > 3 ? 3 : (mrcdyspnea > 2 ? 2 : (mrcdyspnea > 1 ? 1 : 0))) + (s >= 3 ? 2 : (s >= 1 ? 1 : 0)) +	(f <= 35 ? 3 : (f <= 49 ? 2 : (f <= 64 ? 1 : 0)))
        //  form.
        let result = (form.b <= 21 ? 1 : 0) + (form.mrcdyspnea > 3 ? 3 : (form.mrcdyspnea > 2 ? 2 : (form.mrcdyspnea > 1 ? 1 : 0))) + (form.s >= 3 ? 2 : (form.s >= 1 ? 1 : 0)) +	(form.f <= 35 ? 3 : (form.f <= 49 ? 2 : (form.f <= 64 ? 1 : 0)))

        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/BODEx.vue